import React from "react";
import { Stack } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";

import WorkOrderRoutingTableHeader from "./WorkOrderRoutingTableHeader";
import WorkOrderRoutingTableBody from "./WorkOrderRoutingTableBody";
import WorkOrderRoutingTableAddRow from "./WorkOrderRoutingTableAddRow";

import {
  handleAddHelper,
  handleBarcodeHelper,
  onBarcodeScanHelper,
} from "./helper";
import { useScannerHelper } from "../../../helpers";
import { useUserHookFormList } from "../../../components/UsersHookFormSelect";

export const WorkOrderRoutingTable = ({ disabled, options = [] }) => {
  const fieldArrayOptions = useFieldArray({
    name: "routes",
    shouldUnregister: true,
    rules: {
      required: "At least 1 Work Order is required",
    },
  });
  const { append, remove, fields } = fieldArrayOptions;
  const { getValues, setValue } = useFormContext();
  const { users } = useUserHookFormList();

  const handleWorkOrderAdd = (defaultValues) =>
    handleAddHelper({
      defaultValues,
      append,
      getValues,
      setValue,
      options,
    });

  const handleBarcodeScan = ({ routeId }) =>
    handleBarcodeHelper({
      routeId,
      append,
      getValues,
      setValue,
      options,
    });

  const onScan = (barcode = "") =>
    onBarcodeScanHelper({
      barcode,
      options,
      addworkOrder: handleBarcodeScan,
      setValue,
      users,
    });

  useScannerHelper(onScan, [], true);

  return (
    <Stack width="100%" overflow="hidden">
      <WorkOrderRoutingTableHeader />
      <WorkOrderRoutingTableBody {...{ disabled, options, remove, fields }} />
      <WorkOrderRoutingTableAddRow
        {...{ disabled, options, handleWorkOrderAdd }}
      />
    </Stack>
  );
};

export default WorkOrderRoutingTable;
